import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import './Navigation.scss';
import SideMenuItem from '../SideModalTabs/SideModalMenu/SideMenuItem/SideMenuItem';
import { SkipTo } from '@citygross/components';

const isProductPage = type => {
  return (
    type === 'ProductFolderPage' ||
    type === 'RecipeFolderPage' ||
    type === 'CateringFolderPage'
  );
};

const Navigation = ({ nav = {} }) => {
  const navMemo = useMemo(() => {
    if (!nav?.children) return null;

    return [
      {
        name: `${
          isProductPage(nav?.type)
            ? nav?.name === 'Catering'
              ? 'All'
              : 'Alla'
            : ''
        } ${nav?.name}`,
        link: nav?.link,
        id: nav?.id,
        visible: true
      },
      ...(nav?.children?.length ? nav?.children : [])
    ]?.map(categoryItem => {
      return (
        <SideMenuItem
          categoryItem={categoryItem}
          key={categoryItem?.id}
          isSidebar
        />
      );
    });
  }, [nav]);

  return nav && nav.children ? (
    <Fragment>
      <SkipTo selector="#b-main" text="Gå till huvudinnehåll" />

      <nav className="c-navigation" aria-label="Kategorier">
        <ul>{navMemo}</ul>
      </nav>
    </Fragment>
  ) : null;
};

Navigation.propTypes = {
  nav: PropTypes.object,
  activePath: PropTypes.string,
  type: PropTypes.string,
  collapsed: PropTypes.bool,
  onTitleClick: PropTypes.func,
  closeMobileNav: PropTypes.func
};

Navigation.defaultProps = {
  nav: {},
  type: 'scroll',
  collapsed: false
};

export default Navigation;
